import type { FC } from 'react'

import categoryIcon from '../../img/category-icon.svg'
import nextIcon from '../../img/next-icon.svg'
import { SC_DocumentsCategory } from './styled'

type T_CategoryCardProps = {
  title: string
  onClick: () => void
}

export const CategoryCard: FC<T_CategoryCardProps> = ({ title, onClick }) => {
  return (
    <SC_DocumentsCategory onClick={onClick}>
      <img src={categoryIcon} />
      <h5>{title}</h5>
      <img src={nextIcon} />
    </SC_DocumentsCategory>
  )
}
